import CommentList from 'components/blog/comments/comment-list';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import Title from 'core/title';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

const CommentContainer = () => {
    const t = useTranslations('comments');
    const [titleVisible, setTitleVisible] = useState(true);
    const handleAddComment = () => {
        setTitleVisible(false);
    };

    return (
        <LandingSection disableGradient>
            {titleVisible && <Title content={t('title')} titleType="subtitle" />}
            <CommentList handleAddComment={handleAddComment} />
        </LandingSection>
    );
};

CommentContainer.propTypes = {
    pageCode: PropTypes.string,
    isRemote: PropTypes.bool
};

export default CommentContainer;
